// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Box, Skeleton, Space, Stack, Text } from '@mantine/core';
import { FC, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { AgreementDTO } from '../../Types/DocumentT';
import BookitupAddIcon from '../../Atoms/BookitupAddIcon';
import { AgreementS } from '../../Service/AgreementS';
import Agreement from './Agreement';

interface Props {
  agreements: AgreementDTO[];
  documentId: number;
  append: (agreement: AgreementDTO) => void;
  remove: (agreementId: string) => void;
  patch: (agreement: AgreementDTO) => void;
}

const DocumentAgreements: FC<Props> = ({ agreements, append, remove, patch, documentId }) => {
  const [loading, setLoading] = useState(false);
  const { pathname } = useLocation();
  const { length } = agreements;

  const addAgreement = async () => {
    try {
      setLoading(true);
      const { create, createForTemplate } = AgreementS;
      const handler = pathname.includes('settings') ? createForTemplate : create;
      const resJSON = await handler(documentId);
      if (resJSON) {
        append(resJSON);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {!loading && length === 0 && (
        <>
          <Space h="md" />
          <Box
            sx={(theme) => ({
              width: '100%',
              height: 50,
              backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[0],
              borderRadius: 10,
            })}
          />
          <Space h="md" />
          <Box
            sx={(theme) => ({
              width: '100%',
              height: 100,
              backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[0],
              borderRadius: 10,
            })}
          />
          <Text
            mt="xs"
            sx={(theme) => ({
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexWrap: 'wrap',
              color: theme.colorScheme === 'dark' ? 'white' : 'black',
            })}
          >
            Du hast noch keine Einwilligung erstellt. Klicke auf
            <Space w={5} />
            <BookitupAddIcon onClick={addAgreement} />
            <Space w={2} />, um zu beginnen.
          </Text>
        </>
      )}
      {length > 0 && agreements && (
        <>
          <Stack mt="md">
            {agreements.map((agreement, index) => (
              <Agreement
                key={agreement.id}
                index={index}
                remove={remove}
                patch={patch}
                agreement={agreement}
                documentId={documentId}
              />
            ))}
          </Stack>
          {!loading && (
            <Text mt="xs" color="blue" variant="link" sx={{ cursor: 'pointer' }} onClick={addAgreement}>
              + Einwilligung hinzufügen
            </Text>
          )}
        </>
      )}
      {loading && <Skeleton mt="md" width="100%" height={150} />}
    </>
  );
};

export default DocumentAgreements;
